/**
 * @file_purpose  page for showing  Hire your own team
 * @author Sucheta Singha
 * @Date_Created 23-08-2024
 * @Date_Modified 23-08-2024
 */
import React, { useState, useEffect, useLayoutEffect } from 'react'
import { useHistory, useParams, Link } from 'react-router-dom'
import {
  CLabel,
  CSelect,
  CFormGroup,
  CButton,
  CSpinner
} from '@coreui/react'
import { ToastContainer, toast } from 'react-toastify';
import GeneralService from "src/apis/GeneralService";
import Constants from "src/Utility/Constants";
import RouteURL from "src/apis/ApiURL";
import MasterData from "src/Utility/MasterData";
import Team_Structure from './team_structure';


export default function HireYourOwnTeam() {
  const history = useHistory();
  let { category_id } = useParams();

  const [loader, setLoader] = useState(0);
  const [loadingData, setLoadingData] = useState(true);
  const [offers, setOffers] = useState([]);
  const [offerValues, selectedOfferValues] = useState([]);
  const [teamStructure, setTeamStructure] = useState([]);
  const [_teamStructure, _setTeamStructure] = useState([]);
  const [state, setState] = useState({
    service_id: '',
    category_id: '',
    radio_extension: 'Urgent (from 3-4 weeks)'
  })
  const [divHeight, setDivHeight] = useState();
  const [offerHeight, setOfferHeight] = useState();
  const [extensionHeight, setExtensionHeight] = useState();
  const [teamStructureHeight, setteamStructureHeight] = useState();

  const prevValue = JSON.parse(localStorage.getItem('team_structure'))
  const _radio_extension = localStorage.getItem('radio_extension')
  const offer_values = JSON.parse(localStorage.getItem('offerValues'))

  const [scrollOff, setscrollOff] = useState(true);

  const [isMobile, setIsMobile] = useState(window.innerWidth < 768); // Assuming mobile width is below 768px
  console.log("IS DEVICE TYPE MOBILE = ", isMobile)

  useEffect(() => {
    if (prevValue && teamStructure?.length > 0) {
      // console.log(_radio_extension);
      let newFormValues = [...teamStructure]
      prevValue.map(obj => {
        newFormValues.map(category => {
          if (category.category_id === obj.category_id) {
            category.field_values.map((team) => {
              obj.field_values.map((_team) => {
                if (team.team_id === _team.team_id) {
                  team.duration = _team.duration;
                  team.junior_level_count = _team.junior_level_count;
                  team.mid_level_count = _team.mid_level_count;
                  team.senior_level_count = _team.senior_level_count;
                }
              })
            })
          }
        });
      });

      setTeamStructure(newFormValues);
      selectedOfferValues(offer_values);

      setState(prevState => ({
        ...prevState,
        'radio_extension': _radio_extension
      }))


    }


  }, [(teamStructure?.length > 0)])

  useEffect(() => {

    /**
  * @author Sucheta Singha
  * @Date_Created 23-08-2024
  * @Date_Modified 23-08-2024
  * @function async
  * @functionName loadHireTeam
  * @functionPurpose this function gets the list of hire teams.
  *
  * @functionParam {}
  * 
  * @functionSuccess Success status and message.
  *
  * @functionError {Boolean} error is there.
  * @functionError {String} message  Description message.
  */

    async function loadHireTeam() {
      let params = JSON.stringify({
        field_id: null,
        field_category_id: category_id,
      })
      GeneralService.apiPostCallRequestWithoutToken(RouteURL.getHireTeamList, params)
        .then((res) => {
          if (res.status === Constants.API_RESPONSE_STATUS_SUCCESS) {
            setTeamStructure(res.data);
            setLoadingData(false);
            setDivHeight(document.getElementById('table-height').clientHeight);
            setExtensionHeight(document.getElementById('extension-height').clientHeight)
            setteamStructureHeight(document.getElementById('team_structure_top-height').clientHeight)

          }
          else {
            toast.error(res.message, {
              position: toast.POSITION.BOTTOM_RIGHT
            });
          }
        }).catch(error => {
          console.log(error)
        })

    }

    /**
* @author Sucheta Singha
* @Date_Created 23-08-2024
* @Date_Modified 23-08-2024
* @function async
* @functionName loadOffers
* @functionPurpose this function gets the list of offers.
*
* @functionParam {}
* 
* @functionSuccess Success status and message.
*
* @functionError {Boolean} error is there.
* @functionError {String} message  Description message.
*/

    async function loadOffers() {
      GeneralService.apiGetCallRequestWithoutToken(RouteURL.getHireTeamOfferList)
        .then((res) => {
          if (res.status === Constants.API_RESPONSE_STATUS_SUCCESS) {
            setOffers(res.data);
            setLoadingData(false)
            setOfferHeight(document.getElementById('offer-height').clientHeight)
          }
          else {
            toast.error(res.message, {
              position: toast.POSITION.BOTTOM_RIGHT
            });
          }
        }).catch(error => {
          console.log(error)
        })

    }

    if (loadingData) {
      loadHireTeam()
      loadOffers()

    }

  }, [loadingData]);

  const handleCountChange = (e, categoryId, teamId, level, delta) => {
    e.preventDefault();
    const updatedStructure = teamStructure.map(category => {
      if (category.category_id === categoryId) {
        return {
          ...category,
          field_values: category.field_values.map(team => {
            // console.log(team[level] + delta, '-', team[level]);
            if (team.team_id === teamId) {
              return {
                ...team,
                [level]: Math.max((team[level]) + delta, 0),
              };
            }

            return team;
          }),
        };
      }
      return category;
    });
    setscrollOff(false)
    setTeamStructure(updatedStructure);
  };

  const handleDurationChange = (categoryId, teamId, delta) => {
    const updatedStructure = teamStructure.map(category => {
      if (category.category_id === categoryId) {
        return {
          ...category,
          field_values: category.field_values.map(team => {
            if (team.team_id === teamId) {
              return {
                ...team,
                duration: Math.max(team.duration + delta, 1),
              };
            }
            return team;
          }),
        };
      }
      return category;
    });
    // console.log(updatedStructure);
    setTeamStructure(updatedStructure);
  };

  const handleChangeRadio = (e) => {
    const { id, value } = e.target
    setState(prevState => ({
      ...prevState,
      [id]: value
    }))
  }

  const clickApplyRemoveButton = (e, type, offer_id) => {
    // let newOfferValues = [...offerValues]
    let newOfferValues = []
    var index = offers.findIndex(x => { return x.offer_id == offer_id; });
    // newOfferValues([])
    if (type === "apply") {
      newOfferValues.push(offer_id);
      selectedOfferValues(newOfferValues)
    } else {
      let temp = newOfferValues.filter(e => e != offers[index].offer_id)
      selectedOfferValues(temp)
    }

  }




  const handleSubmit = async () => {
    setLoader(1);
    const payload = teamStructure.map(category => ({
      category_id: category.category_id,
      field_values: category.field_values.map(team => ({
        team_id: team.team_id,
        duration: team.duration,
        junior_level_count: team.junior_level_count,
        mid_level_count: team.mid_level_count,
        senior_level_count: team.senior_level_count,
      })),
    }));
    history.push({
      pathname: "/contact-form/hire-your-own-team",
      state: { fields: payload, radio_extension: state.radio_extension, offerValues: offerValues }
    });
    localStorage.setItem('team_structure', JSON.stringify(payload))
    localStorage.setItem('radio_extension', state.radio_extension)
    localStorage.setItem('offerValues', JSON.stringify(offerValues))
  };



  const styles = {
    section: {
      width: '100%',
      background: '#fff',
      padding: 10
    },
    container: {
      fontFamily: 'Arial, sans-serif',
      marginTop: '20px',
    },
    table: {
      marginBottom: '20px',
    },
    listGroupItem: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginRight: 5,
    },
    heading: {
      marginBottom: '20px',
    },
    durationButton: {
      margin: '0 5px',
      padding: '5px 10px',
      cursor: 'pointer',
    },

    estimationButton: {
      backgroundColor: '#f44336',
      color: 'white',
      border: 'none',
      width: '100%',
      padding: '10px',
      cursor: 'pointer',
    },
    header: {
      textAlign: 'center',
    },
  };

  const totalCounts = teamStructure && teamStructure.reduce(
    (acc, category) => {
      category?.field_values?.forEach((team) => {
        acc.junior_level_count += team.junior_level_count;
        acc.mid_level_count += team.mid_level_count;
        acc.senior_level_count += team.senior_level_count;
      });
      return acc;
    },
    { junior_level_count: 0, mid_level_count: 0, senior_level_count: 0 }
  );

  const GoBackClick = (e) => {
    e.preventDefault();
    history.goBack()
  }


  // const sendHeight = () => {
  //   // Send the height of the iframe content to the parent page
  //   window.parent.postMessage(document.body.scrollHeight, '*');
  // }

  // // Send height initially and on content changes
  // window.addEventListener('load', sendHeight);
  // window.addEventListener('resize', sendHeight);

  // const observer = new MutationObserver(sendHeight);
  // observer.observe(document.body, { childList: true, subtree: true });


  // console.log('sendHeight', document.body.scrollHeight);
  const [calTeamStructureHeight, setCalTeamStructureHeight] = useState();
  const [calOfferHeight, setCalOfferHeight] = useState();

  useEffect(() => {
    let newHeight = (parseInt(totalCounts?.junior_level_count) + (parseInt(totalCounts?.mid_level_count) + parseInt(totalCounts?.senior_level_count) > 0 ? 175 : 45))


    setCalTeamStructureHeight(newHeight);
    setCalOfferHeight((parseInt(divHeight) - (parseInt(extensionHeight) + newHeight)))
  }, [divHeight, teamStructureHeight, extensionHeight, offerHeight, teamStructure])



  // console.log(divHeight - ((calTeamStructureHeight + extensionHeight) - 175));
  // scrollOff

  const sendHeight = () => {
    // Send the height of the iframe content to the parent page
    window.parent.postMessage(document.body.scrollHeight, '*');
  };

  // Debounce function to limit the number of times sendHeight is called
  const debounce = (func, delay) => {
    let timer;
    return function () {
      clearTimeout(timer);
      timer = setTimeout(func, delay);
    };
  };

  // Create debounced version of sendHeight
  const debouncedSendHeight = debounce(sendHeight, 100);

  // Send height initially and on content changes
  window.addEventListener('load', debouncedSendHeight);
  window.addEventListener('resize', debouncedSendHeight);

  // Observe changes in the DOM with a slight delay to ensure rendering is complete
  const observer = new MutationObserver(debouncedSendHeight);
  observer.observe(document.body, { childList: true, subtree: true });
  return (
    <body style={{ backgroundColor: "#fff", }}>

      <div className="appoinment_hed">
        <h4>
          TEAM SELECTION
        </h4>
        <div className=''>
          <div className='row'>

            <div className='col-sm-6 col-xl-6 col-lg-6 col-md-6 col-sm-12'>
              <div className='ball_park'>
                <div className='ball_park_num'>
                  <p>1</p>
                </div>
                <div className='ball_park_txt'>
                  <p>Add the required numbers below for the desired Team</p>
                </div>
              </div>
            </div>

            <div className='col-sm-6 col-xl-6 col-lg-6 col-md-6 col-sm-12'>
              <div className='ball_park'>
                <div className='ball_park_num'>
                  <p>2</p>
                </div>
                <div className='ball_park_txt'>
                  <p>Check the Total team and press "Get Estimation" <br />button to get the ballpark price</p>
                </div>
              </div>
            </div>

            {/* <div className='col-sm-4 col-xl-4 col-lg-4 col-md-6 col-sm-12'>
              <div className='ball_park mar_top5'>
                <div className='ball_park_num'>
                  <p>3</p>
                </div>
                <div className='ball_park_txt'>
                  <p>Contact us to get accurate <br />estimations.</p>
                </div>
              </div>
            </div> */}
          </div>
        </div>
        <div className='team_table_main'>
          <div className='row'>
            <div className="col-md-9">
              <div className='selection_table' id='table-height'>
                <table className="table table-bordered" style={styles.table}>
                  <thead>
                    <tr>
                      <th >Team
                        <small style={{ width: "100%", display: "inline-block", fontSize: 13 }}></small>
                      </th>
                      <th style={{ width: "100%", display: "inline-block", fontSize: 13 }}>Duration</th>
                      <th>Junior
                        <small style={{ width: "100%", display: "inline-block", fontSize: 13 }}>1-2 Yrs</small>
                      </th>
                      <th>Mid-Level
                        <small style={{ width: "100%", display: "inline-block", fontSize: 13 }}>3-5 Yrs</small>
                      </th>
                      <th>Senior
                        <small style={{ width: "100%", display: "inline-block", fontSize: 13 }}>5-10 Yrs</small>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {loader ?
                      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'absolute', width: '100%', marginTop: "10%" }}> <CSpinner
                        style={{ width: '4rem', height: '4rem', }}
                        color="danger"
                        variant="grow"
                        className="loader_z_index"
                      />
                      </div>
                      : ""}
                    {teamStructure && teamStructure.map(category => (
                      <React.Fragment key={category.category_id}>
                        <tr className='mt-3'>
                          <td colSpan="5" className="art_txt ">
                            {category.category_name}
                          </td>
                        </tr>
                        {category.field_values.map(team => (
                          <tr className='art_brdr' key={team.team_id}>
                            <td>{team.team_name}</td>
                            <td>
                              <div className="d-flex justify-content-center align-items-center count_team_btn">
                                <button
                                  className="btn btn-sm"
                                  style={styles.durationButton}
                                  onClick={(e) =>
                                    handleDurationChange(category.category_id, team.team_id, -1)
                                  }
                                >
                                  <i class="fa-solid fa-minus"></i>
                                </button>
                                <span className="mx-2">{team.duration} {team.duration == 1 ? 'Month' : 'Months'}</span>
                                <button
                                  className="btn btn-sm "
                                  style={styles.durationButton}
                                  onClick={(e) =>
                                    handleDurationChange(category.category_id, team.team_id, 1)
                                  }
                                >
                                  <i class="fa-solid fa-plus"></i>
                                </button>
                              </div>
                            </td>
                            {['junior_level_count', 'mid_level_count', 'senior_level_count'].map(level => (
                              <td key={level}>
                                <div className="d-flex justify-content-center align-items-center count_team_btn">
                                  <button
                                    className="btn btn-sm "
                                    onClick={(e) =>
                                      handleCountChange(e,
                                        category.category_id,
                                        team.team_id,
                                        level,
                                        -1
                                      )
                                    }
                                    style={styles.durationButton}
                                  >
                                    <i class="fa-solid fa-minus"></i>
                                  </button>
                                  <span className="mx-2">{team[level]}</span>
                                  <button
                                    className="btn btn-sm "
                                    onClick={(e) =>
                                      handleCountChange(e,
                                        category.category_id,
                                        team.team_id,
                                        level,
                                        1
                                      )

                                    }
                                    style={styles.durationButton}
                                  >
                                    <i class="fa-solid fa-plus"></i>
                                  </button>
                                </div>
                              </td>
                            ))}
                          </tr>
                        ))}
                      </React.Fragment>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            <div className="col-md-3" >
              <div className='team_structure' style={{ height:  isMobile?'fit-content':  divHeight }}>
                <div className="row">
                  <div className="col-md-12">
                    <div className='team_structure_top'  >
                      <h3>Team Structure </h3>
                      <div className="list-group" id='team_structure_top-height'>

                        {totalCounts?.junior_level_count + totalCounts?.mid_level_count + totalCounts?.senior_level_count > 0 ?
                          <>

                            <ul style={{
                              borderBottom: '2px solid #13060B', height: 175
                            }}>
                              {teamStructure && teamStructure?.map((category, key) =>
                                category?.field_values.map(team =>
                                  ['junior_level_count', 'mid_level_count', 'senior_level_count'].map(level =>
                                    team[level] > 0 ? (
                                      <li
                                        className="list-group-item"
                                        key={`${team?.team_id}-${level}`}
                                        style={styles.listGroupItem}
                                      >
                                        <div>
                                          {(() => {
                                            switch (level) {
                                              case "junior_level_count":
                                                return "Junior ";
                                              case "mid_level_count":
                                                return "Mid-Level ";
                                              case "senior_level_count":
                                                return "Senior ";
                                              default:
                                                return null;
                                            }
                                          })()}
                                          {team?.team_name}</div>
                                        <div>{team[level]}</div>
                                      </li>
                                    ) : null
                                  )
                                )
                              )}

                            </ul>
                            <div className="d-flex justify-content-between align-center total_team_man">
                              <div>Total Team</div>
                              <div>{totalCounts?.junior_level_count + totalCounts?.mid_level_count + totalCounts?.senior_level_count}</div>
                            </div></>
                          : <span style={{ textAlign: 'center', color: '#a9a8a8' }}>No team member selected</span>}
                      </div>

                    </div>
                  </div>
                  <div className="col-md-12" >
                    <div className='extension' id='extension-height'>
                      <h4>How Soon you need an extension? *</h4>
                      <form>
                        {MasterData.hireTeamExtensionValues.map((item, j) => (
                          <div className="form-check p-0">
                            <div className='require_box extension_box'>
                              <label class={item.id == state.radio_extension ? "con1 label_drk" : "con1"}><span>{item.name}</span>
                                <input name="radio_extension" id="radio_extension" type='radio' value={item.id}
                                  checked={item.id == state.radio_extension}
                                  onChange={handleChangeRadio} />
                                <span class="checkmark"></span>
                              </label>
                            </div>

                          </div>
                        ))}
                      </form>

                    </div>

                  </div>
                  <div className="col-sm-12" id='offer-height'>
                    <div className="apply_block_foundat" style={{ height: isMobile?'fit-content': (calOfferHeight - 175), overflow: 'auto' }}
                    // style={{
                    //   height: (parseInt(totalCounts?.mid_level_count) + parseInt(totalCounts?.senior_level_count) > 0) ? (calOfferHeight - 160) : calOfferHeight,
                    //   overflow: ((parseInt(totalCounts?.mid_level_count) + parseInt(totalCounts?.senior_level_count) > 0) ? 'auto' : '')
                    // }} 
                    >

                      {offers && offers.map((item, i) => (
                        <div className="mb-3" >

                          <div className='foundat_main' >
                            <div className='foundat_main_in'>
                              <div className='foundat_title'>{item.title}</div>
                              <div className='foundat_title1'><span style={{ color: 'red' }}>
                                {item.discount_type === "Percentage" ?
                                  parseInt(item.percentage_of_discount) + "%"

                                  : '$' + parseInt(item.percentage_of_discount)}


                                &nbsp;OFF</span>
                              </div>
                            </div>

                            <div className="foundat_main_btm">
                              <div className="foundat_main_btm_lt">
                                <p>{item.description}</p>
                              </div>
                              <div className="foundat_main_btm_rt">
                                <div className="foundat_apply">
                                  <div className="atten_sec1 text-center">
                                    {offerValues.includes(item.offer_id) ?
                                      <CButton className="cancel" onClick={e => clickApplyRemoveButton(e, "remove", item.offer_id)}>
                                        Remove
                                      </CButton>

                                      :
                                      <CButton className="save" onClick={e => clickApplyRemoveButton(e, "apply", item.offer_id)}>
                                        Apply
                                      </CButton>

                                    }

                                  </div>
                                </div>

                              </div>
                            </div>
                          </div>

                        </div>
                      ))}


                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-sm-12'>
              <div className="booking_btns_sec">
                <div className="atten_sec1 col-12 text-center">
                  <CButton className="cancel"
                    onClick={GoBackClick}
                    style={{
                      background: (totalCounts?.junior_level_count + totalCounts?.mid_level_count + totalCounts?.senior_level_count == 0
                        || !state.radio_extension
                      ) ? '#DFDFDF' : '#ABABAB', marginRight: 10
                    }}
                  > <i class="fa-solid fa-chevron-left"></i>Back</CButton>

                  <CButton className="save esti_btn"
                    onClick={handleSubmit}
                    disabled={(totalCounts?.junior_level_count + totalCounts?.mid_level_count + totalCounts?.senior_level_count == 0
                      || !state.radio_extension
                    ) ? true : false}
                    style={{
                      background: (totalCounts?.junior_level_count + totalCounts?.mid_level_count + totalCounts?.senior_level_count == 0
                        || !state.radio_extension
                      ) ? '#DFDFDF' : '#E84C3D'
                    }}
                  >
                    Get Estimation <i class="fa-solid fa-angle-right right_ang1"></i>
                  </CButton>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


    </body>
  );
};

